import React, { useContext } from "react";
import Utils from "../Utils";
import ContextComponent from "../../components/AppContext";

const Analytics = () => {
  const { setLoadingState } = useContext(ContextComponent);
  const downloadReport = (e) => {
    e.preventDefault();

    const downloadSuccess = (res) => {
      // console.log(res);
      if (!Utils.isObjectEmpty(res.data)) {
        setLoadingState({
          applyMask: false,
        });

        const file = new Blob([res.data], {
          type: "text/x-vcard;CHARSET=utf-8",
        });
        const element = document.createElement("a");
        element.href = URL.createObjectURL(file);

        let fileName = "dbc_all_cards.csv";
        let contentDisposition = res.headers["content-disposition"];

        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          // console.log("fileNameMatch", fileNameMatch);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        console.log(fileName);

        element.download = fileName;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
      } else {
        setLoadingState({
          applyMask: false,
        });
      }
    };
    const downloadFail = (err) => {
      err?.message?.length && console.log(err);
      setLoadingState({
        applyMask: false,
      });
    };

    setLoadingState({
      applyMask: true,
      text: "Downloading all cards",
    });
    Utils.downloadAllCards().then(downloadSuccess, downloadFail);
  };

  return (
    <div className="indi-analytics-wrapper">
      <h2>Download Report</h2>
      <a href="" onClick={downloadReport}>
        Download all cards
      </a>
    </div>
  );
};

export default Analytics;
